(() => {
  const discountBannerCopy = {
    lounge25x8: "Buy 6 Cans, get 6 More FREE! Discount applied at checkout.",
  };

  const findDiscountHandle = () => {
    const segments = window.location.pathname.split("/").filter(Boolean);
    const discountIndex = segments.indexOf("discount");

    if (discountIndex === -1) return null;

    return segments[discountIndex + 1] || null;
  };

  const sessionKey = "lucy:discount-banner-code";

  const persistDiscount = (code) => {
    if (!code) return;
    try {
      sessionStorage.setItem(sessionKey, code);
    } catch (error) {
      console.error("lucy: unable to persist discount code", error);
    }
  };

  const readPersistedDiscount = () => {
    try {
      return sessionStorage.getItem(sessionKey);
    } catch (error) {
      console.error("lucy: unable to read persisted discount code", error);
      return null;
    }
  };

  const readDiscountFromParams = () => {
    try {
      return new URLSearchParams(window.location.search).get("discount");
    } catch (error) {
      console.error("lucy: unable to parse discount query param", error);
      return null;
    }
  };

  const readDiscountFromCookie = () => {
    const match = document.cookie.match(/(?:^|; )discount_code=([^;]+)/i);
    return match ? decodeURIComponent(match[1]) : null;
  };

  const resolveDiscount = () => {
    const fromPath = findDiscountHandle();
    if (fromPath) {
      persistDiscount(fromPath);
      return fromPath;
    }

    const fromQuery = readDiscountFromParams();
    if (fromQuery) {
      persistDiscount(fromQuery);
      return fromQuery;
    }

    const fromSession = readPersistedDiscount();
    if (fromSession) {
      return fromSession;
    }

    const fromCookie = readDiscountFromCookie();
    if (fromCookie) {
      persistDiscount(fromCookie);
      return fromCookie;
    }

    return null;
  };

  const renderBanner = (text) => {
    const target = document.getElementById("warning-banner");
    if (!target || document.getElementById("dynamic-discount-banner")) return;

    const banner = document.createElement("div");
    banner.id = "dynamic-discount-banner";
    banner.textContent = text;
    banner.style.backgroundColor = "#00FF9E";
    banner.style.color = "black";
    banner.style.fontFamily = "monospace";
    banner.style.fontSize = "16px";
    banner.style.fontWeight = "bold";
    banner.style.textTransform = "uppercase";
    banner.style.textAlign = "center";
    banner.style.lineHeight = "45px";
    banner.style.height = "45px";

    target.parentNode.insertBefore(banner, target);
  };

  const init = () => {
    const handle = resolveDiscount();
    if (!handle) return;

    const copy = discountBannerCopy[handle.toLowerCase()];
    if (!copy) return;

    renderBanner(copy);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
